import React from "react";
import { Box, FormControl, Typography, TextField } from "@mui/material";

// "Additional Orders" is a free-text note field rather than a headcount —
// every other service stays a numeric-only count.
const isFreeTextService = (name) => name?.trim().toLowerCase() === "additional orders";

// Per-service counts, limited to this client's own service list.
export default function ServiceCountsGrid({ services, counts, onCountChange, editable }) {
  return (
    <FormControl fullWidth sx={{ mt: 2 }}>
      <Typography variant="subtitle2" sx={{ mb: 1 }}>
        Service Counts
      </Typography>
      {services.length === 0 ? (
        <Typography variant="body2" color="text.secondary">
          This company has no services on file.
        </Typography>
      ) : (
        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2 }}>
          {services.map((service) => (
            <Box key={service} sx={{ flex: { xs: "1 1 45%", sm: "1 1 45%" } }}>
              <Typography variant="body2">{service}</Typography>
              <TextField
                size="small"
                value={counts[service] ?? (isFreeTextService(service) ? "" : 0)}
                onChange={(e) => onCountChange(service, e.target.value)}
                inputProps={isFreeTextService(service) ? undefined : { inputMode: "numeric" }}
                disabled={!editable}
                sx={{ width: {xs:"100%",sm:"100%"}, }}
              />
            </Box>
          ))}
        </Box>
      )}
    </FormControl>
  );
}
